import StandardRadioButton from './standard/main';

export {
  StandardRadioButton,
};
